import React from 'react';
import { ChildProps, graphql } from 'react-apollo';
import gql from 'graphql-tag';
import ListingNudge from '@reverbdotcom/discovery-ui/src/components/discovery/listing_nudge';
import { CartSignals as CartSignalsQuery } from '../schemas/rql';

interface ExternalProps {
  listingId: string;
}

interface Signal {
  name?: string,
  title?: string,
  icon?: string
}

type IProps = ChildProps<ExternalProps, CartSignalsQuery.Query, Location>;

export function CartSignals(
  props: IProps,
) {
  const signals = props.data?.listing?.signals?.filter(signal => ['FREE_STANDARD_SHIPPING', 'FREE_EXPEDITED_SHIPPING', 'PREDICTED_TO_SELL_SOON', 'RETURN_POLICY', 'EXPEDITED_SHIPPING_AVAILABLE'].includes(signal.name));
  if (!signals?.length) { return null; }

  return (
    <>
      {signals.map(signal => {
        return RenderSignal(signal);
      })}
    </>
  );
}

function RenderSignal(signal: Signal) {
  if (!signal.title || !signal.icon) {
    return null;
  }

  const getIconSvg = function () {
    const iconHeight = 20;
    return (
      <svg height={iconHeight}>
        <image href={signal.icon} height={iconHeight} />
      </svg>
    );
  };

  return (
    <ListingNudge
      title={signal.title}
      inline
      icon={getIconSvg()}
      key={signal.title}
    />
  );
}

const withQuery = graphql<IProps, CartSignalsQuery.Query>(
  gql`
    query Cart_Signals(
      $id: String
    ){
      listing(
        input: {id: $id}
      ) {
        _id
        id
        title
        signals (input: { groups: [WHY_TO_BUY, NUDGE]}) {
          name
          title
          icon
        }
      }
    }
  `,
  {
    options: (ownProps) => {
      return {
        errorPolicy: 'all',
        variables: {
          id: ownProps.listingId,
        },
      };
    },
  },
);

export default withQuery(CartSignals);
